// import VueTour from 'vue-tour'
// import 'vue-tour/dist/vue-tour.css'
//
// export default  async ({ Vue }) => {
//     Vue.use(VueTour)
// }